import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from '../components/Footer';
import Header from '../components/Header';

const SikcaSorulanSorular = () => {
    return (
        <>
            <Helmet>
                <title>Sıkça Sorulan Sorular - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Legalbul.com sıkça sorulan sorular." />
            </Helmet>

            <Header />
            <section className="container p-5 my-5 bg-white shadow-sm">
                <ol className="breadcrumbnav">
                    <li>
                        <Link to="/">Ana Sayfa</Link>
                    </li>
                    <li>
                        Sıkça Sorulan Sorular
                    </li>
                </ol>
                <h1>Sıkça Sorulan Sorular</h1>
                <div className="py-4">
                    <h5 className="py-1">1. Legalbul.com'u kimler kullanabilir?</h5>
                    <div>
                        Legalbul.com, herkesin kullanımına açık ve ücretsiz bir hesaplama platformudur. Bu platform;
                        dava süreleri, tazminat hesaplamaları, icra masrafları gibi yargısal konulara ilişkin hesaplamaları
                        yapmak ve bilgi edinmek isteyen herkes tarafından rahatlıkla kullanılacak şekilde tasarlanmıştır.
                    </div>
                </div>
                <div className="py-4">
                    <h5 className="py-1">2. Sitedeki hesaplamalar doğruluğu nedir?</h5>
                    <div>
                        Sitemizdeki hesaplamalar, Türkiye'deki mevcut yasal düzenlemelere ve güncel değişikliklere uygun olup
                        UYAP portal üzerinden doğruluğu teyit edilerek hazırlanmıştır. Fakat belirtmek gerekir ki, platformumuz
                        üzerinden yapılan hesaplamaların sonuçları yalnızca bilgilendirme amacı taşımaktadır.
                    </div>
                </div>
                <div className="py-4">
                    <h5 className="py-1">3. Sitedeki bilgiler güncel midir?</h5>
                    <div>
                        Evet, sitemizdeki bilgiler düzenli olarak güncellenmektedir. Mevzuatların ve masraf kalemlerinin
                        değişmesi durumunda, hesaplamalar ve içeriklerimiz süre kaybetmeksizin güncellenmekte ve
                        kullanıcılarımıza en doğru ve güncel bilgiyi sunulmaktadır.
                    </div>
                </div>
                <div className="py-4">
                    <h5 className="py-1">4. Sitede yapılan hesaplamalar yasal bir bağlayıcılığa sahip midir?</h5>
                    <div>
                        Hayır, sitede yapılan hesaplamalar yalnızca bilgilendirme amacı taşır ve yasal bir bağlayıcılığı
                        bulunmaz. Hukuki süreçlere ilişkin profesyonel bir danışmanlık alınması her zaman önem arz etmektedir.
                    </div>
                </div>
            </section>
            
            <Footer />
        </>
    );
};

export default React.memo(SikcaSorulanSorular);
